import { Setting } from '../../classes/setting/setting.class'

/**
 * @file Defines the {@link NEW_SETTINGS} constant
 * @author Joe Thompson <joe.thompson@1x2gaming.com>
 */

/**
 * Object storing all settings exclusive to new ui
 * @type {object}
 * @constant
 * @default
 * @property {Setting} controls - Inverting controls setting
 */
const NEW_SETTINGS = {

    /** Setting for inverting controls */
    controls: new Setting('inverted__controls', 'Invert controls', 'spin', false)

}

export { NEW_SETTINGS }
